<template>

  <div class="recycle_container">
    <div class="detail_top" ref="pagesRef">
      <el-carousel :height="pagesHeight + 'px'" :autoplay="true" :interval="5000">
        <el-carousel-item v-for="(item,index) in detailImgList" :key="index">
          <img class="imgCls" :src="item.url">
        </el-carousel-item>
      </el-carousel>
    </div>

    <div class="detail_center_one">
      <div class="center_one_title">
        <div class="center_one_title_line"></div>
        <div class="center_one_title_content">智能访客机</div>
        <div class="center_one_title_line"></div>
      </div>

      <div class="center_one_body_current">
        <img style="width: 80%" class="oneBodyImgCls" src="../../assets/images/fk4151_center_001.png"/>
      </div>

    </div>

    <div class="detail_center_two">

      <div class="center_two_a">
        <div class="center_two_a_left"></div>
        <div class="center_two_a_right"></div>
      </div>

      <div class="center_two_b">
        <div class="center_two_b_left"></div>
        <div class="center_two_b_center">智能两分类垃圾箱</div>
        <div class="center_two_b_right"></div>
      </div>

      <div class="center_two_c">
        <div class="center_two_c_a">
          本产品是一款基于Android系统，集成双屏显示、二代身份证读卡器、指纹读取、IC读卡器、ID读卡器、电容触摸、高速热敏打印、二维码/条码扫描仪、摄像头等多个模块，并实现双屏异显、TTS语音、人体感应补光、人脸识别、指纹对比、多网络传输(WiFi/有线以太网)、后台存储等技术为一体的多功能访客进出登记管 理设备。
        </div>
      </div>

      <div class="center_two_d">外观尺寸</div>
      <div class="center_two_e">450mm(宽)*455mm(厚)*447mm(高)</div>

      <div class="center_other_adorn_right">
        <img class="adorn_img" src="../../assets/images/home_center_adorn.png">
      </div>

      <div class="center_two_d">应用场景</div>
      <div class="center_two_e">
        居民社区，公共场所，学校，办公场所
      </div>

      <div class="center_two_d">功能</div>
    </div>

    <div class="detail_center_three">
      <div class="center_three_body_left">
        <div class="three_body_left_left">一</div>
        <div class="three_body_left_right">能详实、快速、有效的记录来访人员指纹信息、图像信息、身份证、卡号等信息，并对来访信息提供便捷的查询；</div>
      </div>

      <div class="center_three_body_right">
        <div class="three_body_right_left">二</div>
        <div class="three_body_right_right">加入了最先进人脸识别技术，自动查找人脸，同时与身份证进行人脸对比，提高门卫管理工作的质量和效率；</div>
      </div>

      <div class="center_three_body_left">
        <div class="three_body_left_left">三</div>
        <div class="three_body_left_right">提升了单位办公形象,进一步降低校园、政府、企业等安全风险。</div>
      </div>

    </div>
    <div class="detail_center_four">
      <img style="width: 26%;margin: 32px 0" src="../../assets/images/fk4151_center_002.png"/>
    </div>
  </div>

</template>

<script>

export default {
  data() {
    return {
      pagesHeight: "",
      detailImgList: [
        {
          url: require("../../assets/images/fk4151_top_001.png")
        }
      ]
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.pagesHeight = this.$refs.pagesRef.clientHeight;
    })

  },
}
</script>

<style lang="less" scoped>

@import "../../assets/css/detailCommonSecond";

@media screen and (max-width: 1280px) {

  .center_one_body_current {
    height: 526px;

    .oneBodyImgCls {
      width: 100%;
      height: 526px;
    }

  }

}

@media screen and (min-width: 1281px) and (max-width: 1440px) {

  .center_one_body_current {
    height: 606px;

    .oneBodyImgCls {
      width: 100%;
      height: 606px;
    }
  }

}

@media screen and (min-width: 1441px) and (max-width: 1920px) {

  .center_one_body_current {
    height: 789px;

    .oneBodyImgCls {
      width: 100%;
      height: 789px;
    }
  }
}

.center_one_body_current {
  display: flex;
  flex-direction: row-reverse;

  .oneBodyImgCls {
  }
}

</style>